// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2dc3c59b","453":"1a1a84dc","455":"cc517a0a","977":"6cf08b73"}[chunkId] + ".chunk.js";
};